import { render, staticRenderFns } from "./OsdEditor.vue?vue&type=template&id=657a39fe&scoped=true&lang=pug&"
import script from "./OsdEditor.vue?vue&type=script&lang=ts&"
export * from "./OsdEditor.vue?vue&type=script&lang=ts&"
import style0 from "./OsdEditor.vue?vue&type=style&index=0&id=657a39fe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657a39fe",
  null
  
)

component.options.__file = "OsdEditor.vue"
export default component.exports